import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/UserOrders'
import { ProductBox } from '../components'

const mapStateToProps = (state, ownProps) => ({
		authenticated : state.Auth.authenticated,
		selected_tags		: state.Product.selected_tags,
		isMobile				: state.Layout.is_mobile
	}),
	mapDispatchToProps = (dispatch, ownProps) => ({ onUserOrdersAddRequest: (list) => dispatch(actions.addUserOrderRequest(list)) })


export default connect(mapStateToProps, mapDispatchToProps)(ProductBox)
